import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';

const SmartButton = (props) => {
  const { label, outline, color, disabled, onClick, type, className } = props;

  return (
    <Button
      className={className}
      color={color}
      outline={outline}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {label}
    </Button>
  );
};

SmartButton.propTypes = {
  label: PropTypes.string,
  outline: PropTypes.bool,
  color: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
};

SmartButton.defaultProps = {
  label: '',
  outline: false,
  disabled: false,
  onClick: null,
  type: 'button',
  className: null,
};

export default withTranslation('common')(SmartButton);
